import { render, staticRenderFns } from "./copyrightfooter.vue?vue&type=template&id=0b131a8c&"
import script from "./copyrightfooter.vue?vue&type=script&lang=js&"
export * from "./copyrightfooter.vue?vue&type=script&lang=js&"
import style0 from "./copyrightfooter.vue?vue&type=style&index=0&id=0b131a8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports